namespace AgerLMS.CMS {
    export class SliderColumns {
        static columnsKey = 'CMS.Slider';
    }
}
